import { Tag, Center } from '@chakra-ui/react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

function TagGroup({ tags }) {
  return (
    tags &&
    Array.isArray(JSON.parse(tags)) &&
    JSON.parse(tags).map((tag) => (
      <Tag key={uuidv4()} m={2} color="teal" size="sm">
        <Center>{tag.toUpperCase()}</Center>
      </Tag>
    ))
  );
}

TagGroup.defaultProps = {
  tags: null,
};

TagGroup.propTypes = {
  tags: PropTypes.string,
};

export default TagGroup;
